import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        account: `From ${ COMMON.en.account }`,
        bogusOffer: "This offer exceeds your wallet's balance.",
        cancel: COMMON.en.cancel,
        evidence: COMMON.en.evidence,
        gasFees: 'Estimated Gas',
        goerliOnly: COMMON.en.goerliOnly,
        howBody: `By clicking, "{0}", you are not committing to a transaction. The transaction will not occur until after the owner accepts your offer and you choose to move forward with the purchase at the offered amount.`,
        name: 'Name',
        offerAmount: 'Offer Amount',
        sendOffer: 'Send this Offer',
        success: 'Successfully made an offer on, "{0}"',
        title: 'Make an Offer on, "{0}"',
        total: 'Estimated Total',
        wrongNetwork: COMMON.en.wrongNetwork,
        ...COMMON.networks
    }
}

export default TRANSLATIONS